import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import Layer from './Layer';
import { CMS_CDN_URL } from "@/config/constants";

// Detect if device is mobile
const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState("");

    useEffect(() => {
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
                navigator.userAgent
            )
        ) {
            setDeviceType("Mobile");
        } else {
            setDeviceType("Desktop");
        }
    }, []);

    return deviceType;
};

const isIosDevice = (): boolean => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

interface AppleDownloadPopupProps {
    closeLayer: () => void;
    isPopupOpen: boolean;
    openedFrom?: string;
}

const AppleDownloadPopupLayer: React.FC<AppleDownloadPopupProps> = ({
    closeLayer,
    isPopupOpen,
    openedFrom,
}) => {
    const deviceType = useDeviceType();

    const ApplePopupContent = () => {
        const isIos = deviceType === "Mobile" && isIosDevice();

        return (
            <>
                {isIos ? (
                    <Box
                        component="div"
                        sx={{
                            textAlign: "center",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                marginLeft: "auto",
                                marginRight: "auto",
                                fontSize: '20px',
                                width: '90%',
                                textAlign: 'center',
                                marginTop: '20px',
                                fontWeight: 700,
                            }}
                        >
                            Let&apos;s design your room!
                        </Typography>
                        <Typography
                            variant="h3"
                            sx={{ marginTop: "10px", marginBottom: "10px", textTransForm: "none !important" }}
                        >
                            Use app for an <i>amazing</i> design experience!
                        </Typography>
                        <Box
                            component="img"
                            src={`${CMS_CDN_URL}/assets/images/apple-dwnld-popup/mweb_popup.png`}
                            alt="Popup"
                            sx={{
                                maxWidth: "95%",
                                margin: "auto",
                                display: "flex",
                            }}
                        />
                        <Box
                            component="div"
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                mt: 2,
                            }}
                        >
                            <a
                                id={`${openedFrom}.appstore_link_clicked`}
                                href="https://apps.apple.com/us/app/nestingale/id6461722582"
                            >
                                <Box
                                    component="img"
                                    src={`${CMS_CDN_URL}/assets/images/apple-dwnld-popup/apple_app_download.png`}
                                    alt="Download on App Store"
                                    sx={{ maxWidth: 180 }}
                                />
                            </a>
                        </Box>
                    </Box>
                ) : (
                    <Box
                        component="div"
                        sx={{
                            textAlign: "center",
                        }}
                    >
                        <Typography variant="h2" sx={{ padding: "10px" }}>
                            We are building exciting features for your phone. Meanwhile, please
                            check out these immersive features on the desktop version of{" "}
                            <strong>www.nestingale.com</strong>!
                        </Typography>
                    </Box>
                )}
            </>
        );
    };

    return (
        <Layer
            open={isPopupOpen}
            onClose={closeLayer}
            dialogTitle=""
            Element={ApplePopupContent}
            dialogContentClassName={"handle-app-download-Layer"}
            maxWidth="sm"
            dialogContentComponentProps=""
        />
    );
};

export default AppleDownloadPopupLayer;
